// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ISO 19115-1 Date type codes for metadata dates
 * @export
 */
export const DateTypeCode = {
  Creation: "creation",
  Publication: "publication",
  Revision: "revision",
} as const;
export type DateTypeCode = (typeof DateTypeCode)[keyof typeof DateTypeCode];

export function instanceOfDateTypeCode(value: any): boolean {
  for (const key in DateTypeCode) {
    if (Object.prototype.hasOwnProperty.call(DateTypeCode, key)) {
      if (DateTypeCode[key as keyof typeof DateTypeCode] === value) {
        return true;
      }
    }
  }
  return false;
}

export function DateTypeCodeFromJSON(json: any): DateTypeCode {
  return DateTypeCodeFromJSONTyped(json, false);
}

export function DateTypeCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateTypeCode {
  return json as DateTypeCode;
}

export function DateTypeCodeToJSON(value?: DateTypeCode | null): any {
  return value as any;
}

export function DateTypeCodeToJSONTyped(value: any, ignoreDiscriminator: boolean): DateTypeCode {
  return value as DateTypeCode;
}
